var _circle, _path, _path2, _circle2, _path3, _path4, _path5, _ellipse, _ellipse2, _circle3, _g, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyOrderPosIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 155,
    height: 150,
    viewBox: "0 0 155 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 82.5,
    cy: 62,
    r: 56,
    fill: "#F1F1F1"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "darken"
    },
    clipPath: "url(#clip0_2084_478)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.3827 106.917C45.8141 113.009 42.712 118.392 42.4906 118.895C42.1583 119.65 42.1151 120.045 42.2198 121.363C42.3275 122.718 42.4298 123.065 42.92 123.829C44.1573 125.766 46.0074 126.721 48.2345 126.544C49.8507 126.434 51.0714 125.814 52.0608 124.634C52.4352 124.174 55.6701 118.819 59.2402 112.745L65.7378 101.676L61.3904 99.1458C59.0194 97.7467 56.8413 96.4257 56.5437 96.2065C56.2647 95.9859 56.0072 95.8009 55.9515 95.8054C55.9159 95.8269 52.9499 100.806 49.3827 106.917Z",
    fill: "#4A66A0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6376 91.5577C57.106 90.7597 58.1328 90.4925 58.9308 90.961L69.372 97.09C70.1701 97.5585 70.4373 98.5852 69.9688 99.3833L67.9332 102.851C66.8791 104.647 64.5689 105.248 62.7733 104.194L55.9447 100.185C54.1491 99.1313 53.5479 96.8212 54.6019 95.0255L56.6376 91.5577Z",
    fill: "#FFCE71"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 73.1709,
    cy: 73.2167,
    r: 22.6905,
    fill: "#C7C4EA",
    stroke: "#4A66A0",
    strokeWidth: 5.58535
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2552 69.5371C57.0545 69.7881 56.9039 70.106 56.9039 70.2733C56.9039 70.8421 57.6735 71.6787 58.7443 72.2643C59.7147 72.7997 59.9657 72.8666 61.0867 72.8666C62.5757 72.8666 63.6633 72.4483 64.6504 71.4779C66.1897 69.9721 64.7006 68.2655 63.0107 69.604C61.7392 70.6079 60.6015 70.6079 59.3132 69.5873C58.5101 68.9515 57.7404 68.9348 57.2552 69.5371Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6917 69.3698C79.0727 69.8048 79.1898 70.7417 79.9594 71.4779C80.8964 72.4149 82.0341 72.8499 83.4228 72.8666C84.6944 72.8666 85.3636 72.6491 86.4679 71.9129C87.3044 71.3608 87.7562 70.5912 87.5888 70.0558C87.271 68.985 86.2838 68.8009 85.2799 69.5873C83.9916 70.6079 82.8539 70.6079 81.5824 69.604C80.8797 69.0519 80.2606 68.9682 79.6917 69.3698Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8575 72.5989C69.3182 73.0004 67.0595 74.6903 66.6078 75.8112C66.3233 76.4805 66.6412 77.2167 67.2937 77.4509C67.963 77.6851 68.4147 77.4844 69.084 76.6478C69.3851 76.2797 69.9875 75.7611 70.4225 75.5101C72.0621 74.5397 74.2037 75.0249 75.5087 76.6478C76.178 77.4844 76.6297 77.6851 77.299 77.4509C77.9515 77.2167 78.2694 76.4805 77.9849 75.8112C77.6671 75.0416 75.927 73.4856 74.8562 73.0171C73.8189 72.5487 71.8279 72.3479 70.8575 72.5989Z",
    fill: "black"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 61.0986,
    cy: 75.451,
    rx: 3.63618,
    ry: 2.02469,
    fill: "#FFB0BA"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 83.9981,
    cy: 76.2888,
    rx: 3.63618,
    ry: 2.02469,
    fill: "#FFB0BA"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2084_478",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 47,
    y: 47,
    width: 52,
    height: 52
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 73.2409,
    cy: 73.2168,
    r: 25.2737,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2084_478)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 123.719,
    cy: 73.2838,
    r: 55.4413,
    fill: "#D9D9D9"
  })))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M126.343 47.8744C126.343 45.131 125.438 42.4643 123.768 40.2878C122.098 38.1114 119.756 36.5468 117.106 35.8367C114.456 35.1267 111.646 35.3109 109.111 36.3608C106.577 37.4106 104.459 39.2674 103.088 41.6433C102.616 42.4613 102.489 43.433 102.733 44.345C102.978 45.2569 103.575 46.0343 104.392 46.5063C105.21 46.9783 106.182 47.1063 107.094 46.8621C108.006 46.6179 108.784 46.0214 109.256 45.204C109.726 44.3928 110.4 43.7191 111.212 43.2505C112.023 42.7818 112.944 42.5345 113.881 42.5335C115.297 42.5335 116.656 43.0962 117.658 44.0978C118.659 45.0994 119.222 46.4579 119.222 47.8744C119.222 49.291 118.659 50.6495 117.658 51.6511C116.656 52.6527 115.297 53.2154 113.881 53.2154H113.872C113.643 53.2383 113.418 53.2845 113.198 53.3532C112.958 53.3782 112.721 53.4266 112.491 53.498C112.295 53.6045 112.11 53.7295 111.937 53.8713C111.733 53.9826 111.54 54.1134 111.36 54.2621C111.2 54.4532 111.061 54.6605 110.944 54.8806C110.814 55.0412 110.699 55.2129 110.599 55.3939C110.522 55.6393 110.471 55.8923 110.447 56.1485C110.385 56.3532 110.342 56.5634 110.32 56.7761V60.3368L110.328 60.3772L110.332 62.1258C110.335 63.0686 110.711 63.9719 111.379 64.6378C112.046 65.3036 112.95 65.6776 113.893 65.6778H113.902C114.846 65.6754 115.751 65.298 116.417 64.6287C117.083 63.9593 117.456 63.0527 117.454 62.1084L117.448 59.7535C120.01 58.9918 122.259 57.4252 123.861 55.2856C125.463 53.146 126.334 50.5473 126.343 47.8744ZM111.379 72.0513C110.879 72.5472 110.537 73.1801 110.397 73.8701C110.257 74.5601 110.324 75.2762 110.591 75.9279C110.858 76.5796 111.311 77.1376 111.895 77.5313C112.479 77.9251 113.166 78.1369 113.87 78.1401C114.815 78.1324 115.72 77.7628 116.4 77.1075C117.061 76.432 117.431 75.5246 117.431 74.5796C117.431 73.6345 117.061 72.7271 116.4 72.0516C115.718 71.4164 114.821 71.0631 113.89 71.0631C112.958 71.063 112.061 71.4162 111.379 72.0513Z",
    fill: "#4A66A0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M45 137.573C59.0833 137.573 70.5 135.206 70.5 132.287C70.5 129.367 59.0833 127 45 127C30.9167 127 19.5 129.367 19.5 132.287C19.5 135.206 30.9167 137.573 45 137.573Z",
    fill: "#F1F1F1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2084_478"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 113.941,
    height: 113.941,
    fill: "white",
    transform: "translate(12.5 30)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyOrderPosIcon);
export default __webpack_public_path__ + "static/media/empty-order-pos-icon.d2b75e5dbbb331cb33a832738c72b2ba.svg";
export { ForwardRef as ReactComponent };